import PropTypes from "prop-types";
import React from "react";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormLabel,
  FormControl,
  FormText,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { BackButton } from "ui/button/back";
import { Notification } from "ui/notification";
import { getErrorDetails } from "util/response";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

class AppUploadPage extends React.PureComponent {
  static get propTypes() {
    return {
      uploadApp: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super();

    this.state = {
      errorDetails: "",
      errorMessage: "",
      submitted: false,
      successMessage: "",
    };

    this._upload = this._upload.bind(this);
    this._doUpload = this._doUpload.bind(this);
  }

  _doUpload() {
    const { uploadApp } = this.props;
    return uploadApp(this.fileInput.files[0])
      .then(() => {
        this.setState({
          errorDetails: "",
          errorMessage: "",
          successMessage: "Application uploaded successfully.",
          submitted: false,
        });
      })
      .catch((e) => {
        const errorDetails = getErrorDetails(e, "field_errors");
        const errorMessage = "There are errors with your application upload.";

        this.setState({
          errorDetails,
          errorMessage,
          submitted: false,
        });
      });
  }

  _upload() {
    this.setState({ submitted: true }, this._doUpload);
  }

  render() {
    const { errorMessage, errorDetails, successMessage, submitted } =
      this.state;

    return (
      <Page title="Upload Application">
        <Box noHeader={true}>
          <Row>
            <Col xs={6}>
              <Notification
                error={errorMessage}
                errorChildren={errorDetails}
                success={successMessage}
                successChildren={
                  <Link to="/applications">Your Applications</Link>
                }
              />
              <FormGroup controlId="file">
                <FormLabel>Select application file</FormLabel>
                <FormControl
                  type="file"
                  ref={(ref) => {
                    this.fileInput = ref;
                  }}
                />
                <FormText>
                  Select the application zip file you want to upload. Your
                  application will be uploaded as a testing version. You will
                  need to manually mark it as stable once uploaded.
                </FormText>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <BackButton />
              <Button
                variant="primary"
                disabled={submitted}
                onClick={this._upload}
              >
                Upload
              </Button>
            </Col>
          </Row>
        </Box>
      </Page>
    );
  }
}

export { AppUploadPage };
